<template>
  <div class="search-filter-box p-6">
    <h4 class="fs-20 font-medium mb-4">
      Price per week
    </h4>

    <checkbox v-model="options.min0">
      {{ currencyData[0] }} ({{ availableBudgetOptions['min0'] || 0 }})
    </checkbox>
    <checkbox v-model="options.min500">
      {{ currencyData[500] }} ({{ availableBudgetOptions['min500'] || 0 }})
    </checkbox>
    <checkbox v-model="options.min1000">
      {{ currencyData[1000] }} ({{ availableBudgetOptions['min1000'] || 0 }})
    </checkbox>
    <checkbox v-model="options.min1500">
      {{ currencyData[1500] }} ({{ availableBudgetOptions['min1500'] || 0 }})
    </checkbox>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'
import currencyRanges from '../../../helpers/currencyRanges';

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox
  },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  computed: {
    ...mapGetters(['availableBudgetOptions']),
    ...mapState(['currency']),
    currencyData(){
      return currencyRanges[this.currency.code].ecoventure.filterLabel
    }
  },
  methods: {
    loadOptions () {
      const filters = this.$store.state.filters
      const budgetValues = filters.budgets.split(',')

      const options = {
        min0: budgetValues.includes('0'),
        min500: budgetValues.includes('500'),
        min1000: budgetValues.includes('1000'),
        min1500: budgetValues.includes('1500')
      }

      return options
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        let newValue = []
        if (options.min0) newValue.push('0')
        if (options.min500) newValue.push('500')
        if (options.min1000) newValue.push('1000')
        if (options.min1500) newValue.push('1500')

        this.$store.commit('setFilter', {
          name: 'budgets',
          value: newValue.join(',')
        })
        this.$store.dispatch('loadProgrammes')
      }
    }
  }
}
</script>